/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Task_ListInputs */



/**
* | output |
* | --- |
* | "Checklist" |
*
* @param {Rte_Task_ListInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_task_list = /** @type {((inputs?: Rte_Task_ListInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Task_ListInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Checklist")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste de tâches")
	return /** @type {LocalizedString} */ ("Checklist")
});